<template>
	<v-container fluid>
		<v-layout row>
			<Header title="Stroje a zariadenia" subtitle="www.duris.info" />
		</v-layout>
		<v-layout row wrap align-center justify-center fill-height class="pt-5">
			<v-flex xs12 sm6 md6 lg6>
				<h2>
					Nábytok vyrábaný na strojoch od firmy EXCELLENT CD
				</h2>
				<img class="pt-5" src="@/assets/excellentcd.jpg" aspect-ratio="1.7" contain width="100%" />
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
	name: "Cooperation",
	components: {
		Header,
	},
	data() {
		return {
			images: [],
		};
	},
};
</script>

<style>

</style>
